import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Link } from "react-router-dom";
import "../../css/banner.css";

const PopupModal = ({ setTab }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Check if the modal has been shown before
    localStorage.removeItem("hasVisited");
    const hasVisited = localStorage.getItem("hasVisited");
    if (!hasVisited) {
      setIsModalOpen(true);
    }
    if (window.location.href.includes("admin")) {
      setIsModalOpen(false);
    }
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    // Set a flag in localStorage to indicate the user has visited
    localStorage.setItem("hasVisited", "true");
  };

  return (
    <>
      <Dialog
        open={isModalOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="banner">
          <div className="left-section">
            <img
              src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/BannerLogo.png"
              alt="Prasad Eye Hospital Logo"
              className="logo"
            />
          </div>
          <div className="right-section">
            <div className="show-logo">
              <img
                src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/logo.png"
                alt="logo"
              />
            </div>
            <p>
              <i
                className="fs-10 flaticon-location ttm-icon_element-color-skincolor margin_right10"
                style={{ fontWeight: 700 }}
              ></i>
              <span style={{ fontSize: "14px" }}>
                Thana Chowk, Ramgarh - 829122, Jharkhand, India
              </span>
            </p>

            <p>
              <i
                className="fs-10 flaticon-phone-call ttm-icon_element-color-skincolor margin_right10"
                style={{ fontWeight: 700 }}
              ></i>
              <a href="tel:7970479666" style={{ fontSize: "14px" }}>
                +91 7970479666
              </a>
            </p>
            <p>
              <i
                className="fs-10 flaticon-email ttm-icon_element-color-skincolor margin_right10"
                style={{ fontWeight: 700 }}
              ></i>
              <a
                href="mailto:prasadeyehospital021@gmail.com"
                style={{ fontSize: "14px" }}
              >
                prasadeyehospital021@gmail.com
              </a>
            </p>
            <div className="top_bar_contact_item top_bar_social">
              <ul className="social-icons">
                <li className="facebook-icon">
                  <a
                    href="https://www.facebook.com/pehramgarh/"
                    aria-label="facebook"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <i
                      className="fs-24 fa fa-facebook margin_right10"
                      style={{ color: "#1877F2" }}
                    ></i>
                  </a>
                </li>
                <li className="instagram-icon">
                  <a
                    href="https://www.instagram.com/pehramgarh/"
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="instagram"
                  >
                    <i className="fs-24 fa fa-instagram margin_right10 gradient-icon"></i>
                  </a>
                </li>
                <li className="twitter-icon">
                  <a
                    href="https://x.com/PEH_Ramgarh/"
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="twitter"
                  >
                    <i
                      className="fs-24 fa fa-twitter margin_right10"
                      style={{ color: "#1DA1F2" }}
                    ></i>
                  </a>
                </li>
                <li className="youtube-icon">
                  <a
                    href="https://www.youtube.com/@prasadeyehospital"
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="youtube"
                  >
                    <i
                      className="fs-24 fa fa-youtube margin_right10"
                      style={{ color: "#FF0000" }}
                    ></i>
                  </a>
                </li>
              </ul>
            </div>
            <Link
              to="/appointment"
              className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark margin_top15 full-button"
              onClick={() => {
                setTab("appointment");
                closeModal();
              }}
            >
              Book Appointment
            </Link>
          </div>
          <span className="close-button" onClick={() => closeModal()}>
            <i className="fa fs-20 fa-close"></i>
          </span>
        </div>
      </Dialog>
    </>
  );
};

export default PopupModal;
